import React from "react"
import { useComputed } from "@preact/signals-react"
import { AppBulkEditDialog } from "@components"

import { reportListMultipleData } from "../../@signals"
import { MULTIPLE_OPTIONS } from "Pages/ReportsAlerts/Reports/@constants"
import ReportListMultipleModalContent from "./Content"
import ReportMultipleModalButtons, { reportsCountLabel } from "./Content/SubmitButtons"

const HEADERS = {
	[MULTIPLE_OPTIONS.SITES]: { icon: 'globe-pointer', title: 'Edit sites' },
	[MULTIPLE_OPTIONS.DATES]: { icon: 'calendars', title: 'Edit pick-up dates' },
	[MULTIPLE_OPTIONS.EMAILS]: { icon: 'envelopes', title: 'Edit emails' },
	[MULTIPLE_OPTIONS.FREQUENCY]: { icon: 'calendar-clock', title: 'Edit frequency' },
	[MULTIPLE_OPTIONS.EXECUTION_DATES]: { icon: 'calendar-lines', title: 'Edit execution date range' },
}


export default function ReportListMultipleModal() {

	const isOpenModal = useComputed(() => !!reportListMultipleData.value?.key)
	const header = HEADERS[reportListMultipleData.value?.key] || {}
	const count = reportListMultipleData.value?.reportsInfo?.length || 0

	return <AppBulkEditDialog
		open={isOpenModal.value}
		onClose={() => reportListMultipleData.value = { values: [], key: '', idReport: [], reportsInfo: [] }}
		icon={header.icon}
		title={header.title}
		subtitle={`${reportsCountLabel(count)} selected`}
		actions={<ReportMultipleModalButtons/>}
	>
		<ReportListMultipleModalContent/>
	</AppBulkEditDialog>
}
